const INTERNAL_ROUTER = Symbol.for('es-internal-router');

export { INTERNAL_ROUTER };
